// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rw-6";
export var imgContainer = "_rw-3";
export var menuIcon = "_rw-5";
export var pillWrapper = "_rw-2";
export var pillsContainer = "_rw-1";
export var subscriptionCard = "_rw-0";
export var subscriptionLogo = "_rw-4";